import { render, staticRenderFns } from "./editMsgTplDialog.vue?vue&type=template&id=3e108f54"
import script from "./editMsgTplDialog.vue?vue&type=script&lang=js"
export * from "./editMsgTplDialog.vue?vue&type=script&lang=js"
import style0 from "./editMsgTplDialog.vue?vue&type=style&index=0&id=3e108f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports